<template>
  <div class="room-management">
    <!-- 搜尋與功能區 -->
    <div class="search-bar-top">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input type="text" placeholder="搜尋湯屋" v-model="searchQuery" />
      </div>
    </div>
    <div class="action-buttons">
      <button
        class="action-button"
        :class="{ active: activeButton === 'all' }"
        @click="setActiveButton('all')"
      >
        顯示所有湯屋
      </button>
      <button
        class="action-button"
        :class="{ active: activeButton === 'checkIn' }"
        @click="setActiveButton('checkIn')"
      >
        使用中
      </button>
      <button
        class="action-button"
        :class="{ active: activeButton === 'checkOut' }"
        @click="setActiveButton('checkOut')"
      >
        閒置中
      </button>
    </div>

    <!-- 表格 -->
    <table class="member-table">
      <thead>
        <tr>
          <th>湯屋編號</th>
          <th>湯屋類型</th>
          <th>使用狀態</th>
          <th>清掃狀態</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="room in paginatedRooms" :key="room.id">
          <td>{{ room.roomNumber }}</td>
          <td>{{ room.roomTypeName }}</td>
          <td>
            <span :class="room.isAvailable ? 'status-tag Y' : 'status-tag N'">
              {{ room.isAvailable ? "閒置中" : "使用中" }}
            </span>
          </td>
          <td>
            <span :class="room.isCleaned ? 'status-tag Y' : 'status-tag N'">
              {{ room.isCleaned ? "已清潔" : "未清潔" }}
            </span>
          </td>
          <td>
            <button @click="editRoom(room.roomNumber)" class="btn btn-edit">
              編輯
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 編輯視窗 -->
    <div v-if="showEditModal" class="edit-modal">
      <div class="modal-content">
        <h2>湯屋資料</h2>
        <div class="form-group">
          <label>湯屋編號</label>
          <input v-model="editRoomData.roomNumber" disabled />
        </div>
        <div class="form-group">
          <label>湯屋類型</label>
          <input v-model="editRoomData.roomTypeName" disabled />
        </div>
        <div class="form-group">
          <label>使用狀態</label>
          <select v-model="editRoomData.isAvailable">
            <option :value="true">閒置中</option>
            <option :value="false">使用中</option>
          </select>
        </div>
        <div class="form-group">
          <label>清掃狀態</label>
          <select v-model="editRoomData.isCleaned">
            <option :value="true">已清潔</option>
            <option :value="false">未清潔</option>
          </select>
        </div>
        <div class="modal-actions">
          <button class="update-button" @click="saveEdit">變更</button>
          <button class="cancel-button" @click="closeEditModal">取消</button>
        </div>
      </div>
    </div>

    <!-- 分頁按鈕 -->
    <div class="pagination">
      <button class="page-btn" :disabled="!hasPreviousPage" @click="prevPage">
        « Previous
      </button>
      <button
        v-for="page in totalPages"
        :key="page"
        :class="['page-number', { active: page === currentPage }]"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>
      <button class="page-btn" :disabled="!hasNextPage" @click="nextPage">
        Next »
      </button>
    </div>
  </div>
</template>

<script>
import spaLogic from "@/assets/js/background/spa.js";

export default {
  name: "SpaManagement",
  mixins: [spaLogic],
};
</script>

<style src="@/assets/css/background/spa.css" scoped></style>
